module.exports = __webpack_public_path__ + "static/media/plusRep.99678394.svg";